window.ScrollTrigger.create({
  trigger: '#vacancy-sidebar',
  start: 'top 15%',
  pin: true,
});
